import { CgiProvider } from "./CGI"

interface Aip {
    Union: string
    EntryDate: string
    OriginalEntryDate: string
}

interface BisnodePhoneList {
    Type: string
    Number: string
    TelemarketingRestriction: boolean
}

interface BisnodeAddressList {
    Type: string
    SubType: string
    StreetName: string
    StreetNumber: string
    PostalCode: string
    City: string
    Country: string
    FormattedAddress: string[]
}

interface BisnodeEnrichment {
    PurchasingPower: string
    PhaseOfLife: string
    HousingType: string
    Education: string
    HousingOwnership: string
}

export interface Bisnode {
    Gedi: string
    ProtectedIdentity: boolean
    FirstNames: string[]
    PreferredFirstName: string
    FamilyName: string
    Gender: string
    DateOfBirth: string
    YearOfBirth: string
    Deceased: boolean
    CommunicationLanguageScript: string
    DirectMarketingRestriction: boolean
    PhoneList: BisnodePhoneList[]
    AddressList: BisnodeAddressList[]
    Enrichment: BisnodeEnrichment
    Deregistered: false
}

export interface CgiActivateResult {
    StatusCode: number
    AutoStartToken?: string
    QrStartToken?: string
    OrderRef?: string
    RequestStartedMilliseconds?: number
}

export interface CgiCollectResult {
    StatusCode: number
    AipResult: Aip | null
    BisnodeResult: Bisnode | null
    PersonalIdentityNumber: string | null
    QrCodeData: string;
    ProgressStatus: CgiProgressStatus;
    UserAge: number;
    IsYoungEnough: boolean;
}

export enum CgiProgressStatus {
    COMPLETE = 0,
    USER_SIGN = 1,
    OUTSTANDING_TRANSACTION = 2,
    NO_CLIENT = 3, 
    USER_REQ = 4,
    STARTED = 5,
}

export interface SubmissionResponse {
    ExtensionData: null
    Messages: string[]
    Success: boolean
}

export interface IsMrmResponse {
    isMrmProduction: boolean;
}

export interface CgiCollectRequest {
    OrderRef?: string;
    QrStartToken?: string;
    RequestStartedMilliseconds?: number;
    provider: CgiProvider;
}
